import Box from '@mui/material/Box'

const Icons = ({ src, alt }) => (
  <Box
    sx={{
      alignItems: 'center',
      display: 'flex',
      height: 92,
      justifyContent: 'center',
      width: 178
    }}
  >
    <Box component='img' alt={alt} src={src} sx={{ width: 147 }} />
  </Box>
)

export default Icons
